import {action, computed, observable, runInAction} from 'mobx'
import {message} from 'antd'
import {get, json} from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class TrainManagementStore {
    @observable loading
    @observable pagination
    @observable page
    @observable list
    @observable brands
    @observable carSeries
    @observable tree
    @observable carList
    @observable modalSelect
    @observable dragList
    @observable editFields
    @observable info
    @observable option
    @observable rowData
    @observable expandedLeftRowKeys
    @observable modal
    @observable page1
    @observable carseriesId //点击查看目录需要的参数id
    @observable carseriesName //点击查看目录需要的参数名字

    constructor() {
        this.loading = false
        this.pagination = {}
        this.page = {
            current: 0,
            total: 1
        }
        this.page1 = {
            current: 0,
            total: 1
        }
        this.list = []
        this.brands = {
            list: [],
            selected: ''
        }
        this.carSeries = {
            list: [],
            selected: ''
        }
        this.tree = []
        this.carList = []
        this.modalSelect = ''
        this.dragList = []
        this.editFields = {}
        this.info = []
        this.option = []
        this.rowData = {}
        this.expandedLeftRowKeys = []
        this.modal = ''
        this.carseriesId = ''
        this.carseriesName = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    @action
    initListPage = async (page, value,type) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        let search = type?'':value
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carseriesCatalog/list`, {
            page: page,
            carseriesName: search
        })
        runInAction(() => {
            if (res && res.status === 0) {
                this.loading = false
                return
            }
            this.list = res.content.map(l => {
                return {
                    id: l.id,
                    brandName: l.brandName,
                    carseriesName: l.carseriesName,
                    state: l.state,
                    brandId: l.brandId,
                    carseriesImage: l.carseriesImage,
                    carseriesId: l.carseriesId,
                    copyStatus: l.copyStatus,
                }
            })
            this.page = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    @action
    initBrands = async () => {
        runInAction(() => {
            this.loading = true
            this.brands = {
                list: [],
                selected: ''
            }
            this.carSeries = {
                list: [],
                selected: ''
            }
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand:brandList`)
        runInAction(() => {
            if (res && res.status === 0) {
                this.loading = false
                return
            }
            this.brands.list = res
            this.loading = false
            this.modalSelect = 'show'
        })
    }

    @action
    initCarseries = async (id) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/list/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carSeries.list = res
        })
    }

    @action
    initCarseriesList = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/carseriesCatalogs`)
        if (res && res.status === 0) {
            message.error('请求车系失败！');
            this.loading = false
            return
        }
        runInAction(() => {
            res.then((c) => {
                this.carList = c
            })
            this.loading = false
        })
    }

    @action
    saveBrandId = (value) => {
        runInAction(() => {
            this.brandId = value
        })
    }

    @action
    saveCarSeriesId = (value) => {
        runInAction(() => {
            this.carSeriesId = value
        })
    }

    @action
    saveCatalog = async () => {
        runInAction(() => {
            this.loading = true
        })
        //If NUll
        if (!this.brandId||!this.carSeriesId||this.brandId.length === 0 || this.carSeriesId.length === 0) {
            message.warning('请选择品牌和车系')
            this.loading = false
            return
        }
        //Get Brand Info
        let brand = []
        const brandList = this.brands.list
        for (let i = 0; i < brandList.length; i++) {
            if (brandList[i].id === this.brandId) {
                brand = brandList[i]
            }
        }
        //Get carSeries Info
        let carSeries = []
        const carSeriesList = this.carSeries.list
        for (let i = 0; i < carSeriesList.length; i++) {
            if (carSeriesList[i].id === this.carSeriesId) {
                carSeries = carSeriesList[i]
            }
        }
        //Save
        const data = {
            'carseriesName': carSeries.defaultName,
            'carseriesImage': carSeries.icon,
            'carseriesId': carSeries.id,
            'brandName': brand.defaultName,
            'brandId': brand.id,
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carseriesCatalog/add`, data)
        runInAction(() => {
            if (res.status === 0) {
                this.loading = false
                return
            }
            if (res.status === 1) {
                if (res.data === '新增成功') {
                    message.success(res.data)
                } else {
                    message.warning(res.data)
                }
            }
            this.loading = false
            this.modalSelect = 'hide'
        })
        this.initListPage(this.page)
    }

    @action.bound
    cancelEdit() {
        this.loading = false
        this.modalSelect = 'hide'
    }

    /***
     * 删除
     * @param rocord
     * @returns {Promise<void>}
     */
    @action
    deleteByCarseriesId = async (rocord) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carseriesCatalog/delete?id=${rocord.id}`)
        runInAction(() => {
            if (res && res.status === 0) {
                return
            }
            this.initListPage(this.page)
        })
    }

    /**
     * 发布/撤销
     */
    @action
    publishByCarseriesId = async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        let state = rocord.state ? 0 : 1;
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carseriesCatalog/${rocord.id}/state/${state}`)
        runInAction(() => {
            if (res && res.status === 0) {
                message.error('发布失败！');
                this.loading = false
                return
            }
            if (state === 1) {
                message.success('发布成功！');
            } else {
                message.success('撤销成功！');
            }
            this.loading = false
        })
        this.initListPage(this.page.current)
    }

    @action
    getList = async () => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService//boutique/type/catalogTreeList`)
        runInAction(() => {
            this.loading = false
            if (res.status === 0) {
                return
            }
            this.tree = Array.isArray(res) ? res : []
        })
    }

    @action
    getTableList = async (page) => {
        this.loading = true
        let id = this.rowData.id?this.rowData.id:''
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/lv1BelowCatalog/${id}`,{
            page: page?page-1:0,
            size: 10
        })
        runInAction(() => {
            if (res.status === 0) {
                this.loading = false
                return
            }
            this.loading = false
            this.dragList = Array.isArray(res.content) ? res.content : []
            this.page1 = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }

    @action
    showAddFirstBox = (record, option) => {
        runInAction(() => {
            this.editFields.content = ''
        })
        runInAction(() => {
            this.info = record
            this.option = option
            this.modal = 'show'
        })
    }

    @computed get fields() {
        let fields = {
            content: {value: this.editFields.content},
            code: {value: this.editFields.code}
        }
        return fields
    }

    @action.bound
    onEditFieldChange(changedFields) {
        const fields = {...this.fields, ...changedFields}
        let editFields = {
            content: fields.content.value,
            code: fields.code.value

        }
        this.editFields = editFields
    }

    @action
    operation = async (content, info, option) => {
        runInAction(() => {
            this.loading = true
        })
        if (!info && !option) {
            const data = {
                "code": content.code,
                "name": content.content,
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/insertFirstLevelDirectory`, data)
            runInAction(() => {
                this.loading = false
                if (res.status === 0) {
                    return
                }
                this.modal = 'hide'
                this.getList()
                this.getTableList()
                this.editFields = {}
                this.rowData.id ? this.clickRow(this.rowData) : this.getTableList()
            })
        }
    }

    @action
    closeBox = () => {
        this.modal = false
        this.editFields = {}
    }

    /***
     * 点击左边目录树显示右边数据
     */
    @action
    clickRow = async (record) => {
        this.loading = true
        this.dragList = []
        this.rowData = record
        if (record.level===1) {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/lv1BelowCatalog/${record.id}`,{
                page: 0,
                size: 10
            })
            runInAction(() => {
                if (res.status === 0) {
                    this.loading = false
                    return
                }
                this.dragList = Array.isArray(res.content) ? res.content : []
                this.page1 = {
                    current: res.number + 1,
                    total: res.totalElements
                }
                this.loading = false
            })}
        else {
            this.dragList.push({
                name:record.name,
                code: record.code,
                id: record.id,
                level: record.level,
                pId: record.pId,
                sort: record.sort
            })
            this.page1 = {
                current: 1,
                total: 1
            }
            this.loading = false
        }
        this.loading = false
    }

    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
    }

    @action
    initGetRightTable = async (page) => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/lv1CatalogList`,{
            page: page?page-1:0,
            size: 10
        })
        runInAction(()=> {
            if (res.status === 0) {
                this.loading = false
                return
            }
            this.dragList = Array.isArray(res.content) ? res.content : []
            this.page1 = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
            this.isShow = false
        })
    }

}

export default new TrainManagementStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/BoutiqueCatalog/BoutiqueTrainManagement/store.js